import React from 'react';
import Row from '../../Common/Row';
import Button from 'kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';
import Inputs from 'components/Inputs';

const WorkSpaceScorecardWizard = ({
  options,
  onAddClicked,
  onBackClicked,
  isValid,
}: {
  options: DropdownOption[];
  onAddClicked: () => void;
  onBackClicked: () => void;
  isValid: boolean;
}) => (
  <div>
    <div style={{ marginBottom: 24 }}>
      <Typography.Header type={'H5'}>Add Scorecard</Typography.Header>
    </div>
    <div style={{ marginBottom: 32 }}>
      <div style={{ marginBottom: 4 }}>
        <Typography.Body type="Label">Scorecard</Typography.Body>
      </div>
      <Inputs.Dropdown
        options={options}
        isSearchEnabled
        fullWidth
        placeholder="Select a Scorecard"
      />
    </div>
    <Row spaceBetween>
      <Button
        onClick={onBackClicked}
        type="Secondary"
        size="Small"
        label="Back"
      />
      <Button
        onClick={onAddClicked}
        isDisabled={!isValid}
        type="Primary"
        size="Small"
        label="Add"
      />
    </Row>
  </div>
);

export default WorkSpaceScorecardWizard;
